import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

// import { SharedMethods } from '../../util/sharedMethods-service';
import { ApiUtils } from '../../shared/services/ApiUtils';
import { Validator } from '../../../modals/validator';
import { MatDialogRef } from '@angular/material';
import { User } from 'src/app/modals/user';
import { FormControl, Validators } from '@angular/forms';
import { Token } from 'src/app/modals/token';
import { SharedMethods } from '../../shared/services/sharedMethods-service';
import { NgxSpinnerService } from 'ngx-spinner';

// on renomme le AuthService en SocialAuthservice pour ne pas créer de conflit avec le AuthServce du projet
import { GoogleLoginProvider, FacebookLoginProvider, AuthService as SocialAuthService } from 'angularx-social-login';



/*import { NbThemeService } from '@nebular/theme';
import { ElectronService } from 'ngx-electron';

import { LocalDataSource } from 'ng2-smart-table';

import { SmartTableService } from '../../@core/data/smart-table.service';

import {DatabaseService} from "../../data-access/database.service";
import {User} from "../../data-access/entities/user.entity"; */

declare var google: any;

@Component({
  selector: 'app-login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html',
})
export class SadevLoginComponent implements OnDestroy, OnInit, AfterViewInit {

  @Input() affiliate ;

  private alive = true;

  user = new User();

  secondpassword = '';

  

  screenType = 'login';

  codechangepass = '';
  newpass = '';
  secondnewpass = '';

  // code = '';

  // validation formulaire d'inscription et de connexion
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  // matcher = new MyErrorStateMatcher();

  constructor(
    public OAuth: SocialAuthService,
    private router: Router,
    public authservice: AuthService,
    public apiUtils: ApiUtils,
    public sharedMethods: SharedMethods,
    public spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<SadevLoginComponent>,) {

    let login = '';
    if (this.authservice.token !== undefined && this.authservice.token !== null)
    login = this.authservice.token.user.email;

    this.authservice.credentiales = {
      login: '',
      password: '',
    };

  }

  ngOnInit() {

    this.authservice.loginEvent.subscribe(() => {

      this.dialogRef.close();

    });

    this.authservice.isLoginPage = true;

    // on ferme les fenêtres modal
    // this.activeModal.close();

  }



  public socialSignIn(socialProvider: string) {

    let socialPlatformProvider;

    if (socialProvider === 'facebook') {
      socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
    } else if (socialProvider === 'google') {
      socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    }

    this.OAuth.signIn(socialPlatformProvider).then(socialusers => {

      console.log(socialProvider, socialusers);

      this.spinner.show();

      this.authservice.socialAuthenticate(socialusers.name, socialusers.email).subscribe( (data: Token) =>  {

        this.authservice.token = data;

        // on attribut un role par defaut en attendant d'implémenter la fonctionnalité d'attribution des rôles
        // this.token.user.roles = ['ADMIN'];

        this.authservice.login(this.affiliate);

        this.spinner.hide();


      },
      err => {

        // tslint:disable-next-line:no-console
        // console.log(err);
        this.spinner.hide();
        this.sharedMethods.errorApiShow(err.error.code, err.error.message);

      });
      // console.log(socialusers);
      // this.Savesresponse(socialusers);
    });

  }


  ngAfterViewInit(): void {


    google.accounts.id.initialize({
      client_id: "197030743042-j2jlqfb7kciq0q7b17v4nnma8t7us0mb.apps.googleusercontent.com",
      callback: (response: any) => this.handleGoogleSignIn(response)
    });
    
    google.accounts.id.renderButton(
      document.getElementById("buttonConnectGoogle"),
      { size: "large", type: "string", text: "Connexion avec Google", shape: "pill", theme: "filled_black", logo_alignment: "center" }  // customization attributes
    );

  }


  handleGoogleSignIn(response: any) {
    console.log(response.credential);
    // reponse.credential contient le token d'identification de l'utilisateur
    // Vous pouvez l'envoyer à votre serveur pour vérifier l'authenticité de l'utilisateur
    

    // This next is for decoding the idToken to an object if you want to see the details.
    let base64Url = response.credential.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    console.log(JSON.parse(jsonPayload));
    /* {
      "iss": "https://accounts.google.com",
      "azp": "515628835107-an8ulmriu129cim62j1ln11e323pv2cf.apps.googleusercontent.com",
      "aud": "515628835107-an8ulmriu129cim62j1ln11e323pv2cf.apps.googleusercontent.com",
      "sub": "104351289345774759363",
      "email": "paulyemdji@gmail.com",
      "email_verified": true,
      "nbf": 1751037355,
      "name": "Paul Eric",
      "picture": "https://lh3.googleusercontent.com/a/ACg8ocIwkNuO6cS83uRgDlEQQ912OauLdPXbN6vUcr_NpFKpQpN_jj5Q=s96-c",
      "given_name": "Paul",
      "family_name": "Eric",
      "iat": 1751037655,
      "exp": 1751041255,
      "jti": "3a3369bdfbde2fac980091c7400fbf01692be600"
    } */

    const user = JSON.parse(jsonPayload);

    if(user.email && user.email_verified ) {

      this.spinner.show();

      this.authservice.socialAuthenticate(user.name, user.email).subscribe( (data: Token) =>  {

        this.authservice.token = data;

        // on attribut un role par defaut en attendant d'implémenter la fonctionnalité d'attribution des rôles
        // this.token.user.roles = ['ADMIN'];

        this.authservice.login(this.affiliate);

        this.spinner.hide();


      },
      err => {

        // tslint:disable-next-line:no-console
        // console.log(err);
        this.spinner.hide();
        this.sharedMethods.errorApiShow(err.error.code, err.error.message);

      });

    }
    else {
      // L'utilisateur n'a pas vérifié son email, vous pouvez afficher un message d'erreur ou rediriger vers une page d'erreur
      console.error("Email non vérifié ou manquant");
    }
   

  }

  

  ngOnDestroy() {
    this.alive = false;
  }

  sendcode() {

    if(this.authservice.credentiales.login !== '' && this.authservice.credentiales.login !== undefined) {

      this.spinner.show();
      this.authservice.forgetPass().subscribe( data =>{
        // alert(data);
        // this.codeSend = true;
        this.screenType = 'changepass';
        this.spinner.hide();
      },
      err => {

        // tslint:disable-next-line:no-console
        // console.log(err);
        this.spinner.hide();
        this.sharedMethods.errorApiShow(err.error.code, err.error.message);

      });

    } else {

      alert('Entrez votre adresse email')
    }

  }


  passchange() {

    if( this.newpass === this.secondnewpass ) {

      this.spinner.show();
      this.authservice.changePass(this.codechangepass, this.newpass).subscribe( (data: Token) =>{
        // alert(data);
        // this.codeSend = true;
        // this.screenType = 'changepass';
        this.authservice.token = data;
      // sauvegarde dans le localstorage

        this.authservice.login(this.affiliate);

        this.spinner.hide();

      },
      err => {

        // tslint:disable-next-line:no-console
        // console.log(err);
        this.spinner.hide();
        this.sharedMethods.errorApiShow(err.error.code, err.error.message);

      });

    } else {

      alert('Nouveaux mots de passe invalides');

    }
  }

  login() {

    let valid: Validator;
    valid = this.validateCredential(this.authservice.credentiales);

    if (valid.result) {

        // this.dialogRef.close(this.partenaireEdit);

        // alert(JSON.stringify(this.authservice.credentiales));

        this.spinner.show();
        this.authservice.authenticate().subscribe((data: Token) =>  {

          this.authservice.token = data;

          // on attribut un role par defaut en attendant d'implémenter la fonctionnalité d'attribution des rôles
          // this.token.user.roles = ['ADMIN'];

          this.authservice.login(this.affiliate);

          this.spinner.hide();


        },
        err => {

          // tslint:disable-next-line:no-console
          // console.log(err);
          this.spinner.hide();
          this.sharedMethods.errorApiShow(err.error.code, err.error.message);

        });


    } else {

        alert('error '+ valid.title + ':' + valid.message);

    }


  }

  registration() {


    if(this.user.name === '') {
      alert( 'Nom incorrecte');
      return
    }

    if(this.user.email === '') {
      alert( 'Email incorrecte');
      return
    }


    if(this.secondpassword !== this.user.password) {
      alert( 'Mots de passe incorrectes');
      return
    }
    // this.partner.id = 0;
    this.user.is_active = true;

    this.spinner.show();

    this.authservice.createUser(this.user).subscribe((data: Token) => {

      this.spinner.hide();

      this.sharedMethods.successApiShow('Votre compte a été crée avec succès.');

      this.authservice.token = data;
      // sauvegarde dans le localstorage

      this.authservice.login(this.affiliate);

    },
    err => {
      this.spinner.hide();
      this.sharedMethods.errorApiShow(err.error.code, err.error.message);
      // alert(JSON.stringify(err));
    });
    // this.editUser(user, 'add');
  }

  validateCredential(credential: any): Validator {

    // tslint:disable-next-line:prefer-const
    let validator = new Validator();
    validator.result = true;

    if (credential.login === '' || credential.login === undefined) {
      validator.result = false;
      validator.title = 'Login invalide';
      validator.message = 'Veillez renseigner une adresse email ou un idenfiant valide';
      return validator;
    }

    if ( credential.password === null || credential.password === '') {
      validator.result = false;
      validator.title = 'Mote de passe invalide';
      validator.message = 'Veillez renseigner votre mot de passe';
      return validator;
    }

    return validator;

  }

  public close(): void {
    this.dialogRef.close();
  }


}
